






























































































































import { VbSnackbarService } from 'bag-of-holding-library';
import { Vue, Component, Prop } from 'vue-property-decorator';
import CountryFlag from 'vue-country-flag';
import Assessment from '@/domain/assessment/entity/assessment';
import EmployeeAssessmentResponse from '@/domain/assessment/entity/emp-assessment-response';
import SkillResponse from '@/domain/assessment/entity/skill/entity/skill-response';
import AssessmentService from '@/domain/assessment/service/assessment.service';
import Priority from '@/domain/activity/entity/priority.entity';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import AssessmentItem from '@/domain/assessment/entity/assessment-item.entity';
import SkillTypes from '../../drd-2.0/skill/skill-types.json';
import AssessmentItemComponent from './assessment-item.component.vue';
import AssessmentResultPercentGraph from '../components/assessment-result-percent-graph.component.vue';
import AssessmentActionsSpeedDial from './assessment-actions-speed-dial.vue';
import AssessmentOverviewCards from './assessment-overview-cards.component.vue';
import AssessmentHeaderCard from './assessment-header-card.component.vue';

@Component({
  components: {
    AssessmentItemComponent,
    AssessmentResultPercentGraph,
    AssessmentActionsSpeedDial,
    AssessmentOverviewCards,
    AssessmentHeaderCard,
    LabelSlot,
    CountryFlag,
  },
})
class AssessmentComponent extends Vue {
  @Prop({
    type: Object,
    required: true,
  }) assessment!: Assessment;


  @Prop({
    type: String,
    required: true,
  }) employeeId!: string;

  @Prop({
    type: Array,
    default: () => [],
  }) priorityItems!: Priority[];

  @Prop({
    type: Boolean,
    default: false,
  }) isSimulation!: boolean;

  @Prop({
    type: Boolean,
    default: false,
  }) isUserLoggedIn!: boolean;

  isEditMode: boolean = false;

  loadingSave: boolean = false;

  search: string = '';

  skillTypes = SkillTypes;

  fab: boolean = false;

  language: string = 'PTBR';

  languages = [
    {
      text: 'Português (Brasil) - pt-br',
      acronym: 'PTBR',
      acronymFlag: 'BR',
    },
    {
      text: 'Inglês (USA) - en-us',
      acronym: 'EN',
      acronymFlag: 'US',
    },
    {
      text: 'Espanhol - es',
      acronym: 'ES',
      acronymFlag: 'ES',
    },
  ];

  userLoggedId: string = '';

  save() {
    if (this.isSimulation) {
      this.saveSimulation();
      return
    }
    this.saveCurrentAssignment();
  }

  saveSimulation() {
    this.loadingSave = true;
    const skillResponses = this.assessment.items
      .map(item => new SkillResponse(
        {
          keyAreaSkillId: item.keyAreaSkillId,
          response: item.response.value,
        },
      ));
    const body = new EmployeeAssessmentResponse(
      { levelId: this.assessment.levelId, assessmentId: this.assessment.id },
    );
    body.skillResponses = skillResponses;
    AssessmentService.createByAssignmentId(this.assessment.assignmentId, body)
      .then(() => {
        VbSnackbarService.showSuccess('Assessment salvo com sucesso!');
        this.isEditMode = false;
        this.$emit('saved');
      })
      .catch((error) => {
        VbSnackbarService.handleHttpError(error);
      }).finally(() => {
        this.loadingSave = false;
      });
  }

  saveCurrentAssignment() {
    this.loadingSave = true;
    const skillResponses = this.assessment.items
      .map(item => new SkillResponse(
        {
          keyAreaSkillId: item.keyAreaSkillId,
          response: item.response.value,
        },
      ));
    const body = new EmployeeAssessmentResponse(
      { levelId: this.assessment.levelId, assessmentId: this.assessment.id },
    );
    body.skillResponses = skillResponses;
    AssessmentService.create(this.employeeId, body)
      .then(() => {
        VbSnackbarService.showSuccess('Assessment salvo com sucesso!');
        this.isEditMode = false;
        this.$emit('saved');
      })
      .catch((error) => {
        VbSnackbarService.handleHttpError(error);
      }).finally(() => {
        this.loadingSave = false;
      });
  }

  filterAssessmentItemsByType(typeValue: string) {
    let items = this.assessment.items.filter(item => item.type.value === typeValue);
    if (this.search.length > 3) {
      items = items.filter(item => item.whatPTBR.toLowerCase().includes(this.search.toLowerCase()));
    }
    switch (this.selectedStatus) {
      case 'adherent':
        items = items.filter(item => item.isAdherent);
        break;
      case 'notAdherent':
        items = items.filter(item => !item.isAdherent
          && !item.isNotApplicable && !item.notAnswered);
        break;
      case 'notAnswered':
        items = items.filter(item => item.notAnswered);
        break;
      case 'all':
      default:
        break;
    }
    return items;
  }

  selectedStatus: string = 'all';


  skillByTypeCount(typeValue: string) {
    return this.assessment.items.filter(item => item.type.value === typeValue).length;
  }

  backToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  cancelEdit() {
    this.isEditMode = false;
  }

  itemIsActive(item: AssessmentItem) {
    return this.activeSkillTypes.some(skillType => skillType.value === item.type.value);
  }

  get activeSkillTypes() {
    return this.skillTypes.filter(skillType => skillType.active && skillType.value !== 'RESPONSIBILITY')
      .sort((a, b) => a.order - b.order);
  }

  get isNotAdherentItems() {
    return this.assessment.items.filter(item => !item.isAdherent
      && !item.isNotApplicable && !item.notAnswered
      && item.type.value !== 'RESPONSIBILITY' && this.itemIsActive(item));
  }

  get isAdherentItems() {
    return this.assessment.items.filter(item => item.isAdherent && !item.notAnswered
    && item.type.value !== 'RESPONSIBILITY' && this.itemIsActive(item));
  }

  get inProgressItemsCount() {
    return this.assessment.items.filter(item => item.planId && !item.isAdherent).length;
  }

  get showSaveButton() {
    return this.isUserLoggedIn && (this.isEditMode || !this.assessment.id);
  }

  get showEditButton() {
    if (!this.isUserLoggedIn) {
      return false;
    }
    if (!this.assessment.id) {
      return false;
    }
    return !this.isEditMode;
  }

  get allItemsCount() {
    return this.assessment.items.filter(item => item.type.value !== 'RESPONSIBILITY'
       && this.itemIsActive(item)).length;
  }

  get notAnsweredItemsCount() {
    return this.assessment.items.filter(
      item => (item.response == null || item.response.value == null)
      && item.type.value !== 'RESPONSIBILITY' && this.itemIsActive(item),
    ).length;
  }
}
export default AssessmentComponent;
